import React, { Component } from 'react';
import PropTypes from 'prop-types';
import debounce from 'utils/debounce';
import validators from 'app/scripts/utils/validators';
import TextField from '../text-field';
import { withEditSpot } from '../../../../../spots/hoc/withEditSpot';

class UrlInput extends Component {
  constructor(props, context) {
    super(props, context);
    var value = props.value;
    this.state = {
      status: 'none',
      message: '',
      websiteUrl: value ? value : null
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.validate) {
      this.onWebsiteUrlChange(this.state.websiteUrl, true);
    }
  }

  UNSAFE_componentWillMount() {
    this.saveWebsiteUrl = debounce(this.saveWebsiteUrl.bind(this), 1000);
  }

  saveWebsiteUrl() {
    if (this.props.autoSave && this.state.status === 'success') {
      this.props.editSpot(this.props.spotId, { website_url: this.state.websiteUrl });
    }
  }

  onWebsiteUrlChange(websiteUrl, onlyUpdate) {
    var empty = !websiteUrl || !websiteUrl.trim().length;
    var valid = validators.url(websiteUrl);
    var state = this.state;

    onlyUpdate = !!onlyUpdate;

    state.status = 'none';
    state.message = '';
    if (empty) {
      state.message = "You can't leave this empty.";
      state.status = 'error';
    } else if (!valid) {
      state.message = 'That is not a valid url.';
      state.status = 'error';
    } else {
      state.status = 'success';
      state.message = '';

      if (!onlyUpdate) {
        this.saveWebsiteUrl();
      }
    }

    state.websiteUrl = websiteUrl;
    this.setState(state);
  }

  getValue() {
    return this.state.websiteUrl;
  }

  isValid() {
    return this.state.status === 'success';
  }

  render() {
    var websiteUrl = this.state.websiteUrl;
    var validation = {
      status: this.state.status || 'none',
      message: this.state.message
    };

    return (
      <TextField
        type="text"
        className="outside"
        onChange={this.onWebsiteUrlChange.bind(this)}
        title="Site URL"
        description="Fill in the URL where you want OpenWeb to be embedded."
        showValidationTooltip
        validation={validation}
        value={websiteUrl}
      />
    );
  }
}

UrlInput.propTypes = {
  autoSave: PropTypes.bool,
  showValidationTooltip: PropTypes.bool,
  spotId: PropTypes.string,
  validate: PropTypes.bool,
  value: PropTypes.string
};

UrlInput.defaultProps = {
  autoSave: false,
  showValidationTooltip: false,
  spotId: null,
  value: null
};

UrlInput.displayName = 'UrlInput';

export default withEditSpot(UrlInput);
